import React from "react";
import styled from "styled-components";

import BasicHeaderSection from "../../sections/BasicHeaderSection";
import TermsSection from "../../sections/TermsSection";
import TitleSectionFederal from "../../V2-federal/sections/TitleSection";
import TermsSectionFederal from "../../V2-federal/sections/TermsSection";
import TitleSectionReflection1 from "../../V2-reflection-1/sections/TitleSection";
import TermsSectionReflection1 from "../../V2-reflection-1/sections/TermsSection";
import TitleSectionReflection2 from "../../V2-reflection-2/sections/TitleSection";
import TermsSectionReflection2 from "../../V2-reflection-2/sections/TermsSection";
import TitleSectionReflection3 from "../../V2-reflection-3/sections/TitleSection";
import TermsSectionReflection3 from "../../V2-reflection-3/sections/TermsSection";
import TitleSectionReflection4 from "../../V2-reflection-4/sections/TitleSection";
import TermsSectionReflection4 from "../../V2-reflection-4/sections/TermsSection";

const StyledTermsPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 100px);

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);
  }
`;

function TermsPage() {
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledTermsPage>
        <TitleSectionFederal
          title="Terms of Use"
        />
        <TermsSectionFederal />
      </StyledTermsPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledTermsPage>
        <TitleSectionReflection1
          title="Terms of Use"
        />
        <TermsSectionReflection1 />
      </StyledTermsPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledTermsPage>
        <TitleSectionReflection2
          title="Terms of Use"
        />
        <TermsSectionReflection2 />
      </StyledTermsPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledTermsPage>
        <TitleSectionReflection3
          title="Terms of Use"
        />
        <TermsSectionReflection3 />
      </StyledTermsPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledTermsPage>
        <TitleSectionReflection4
          title="Terms of Use"
        />
        <TermsSectionReflection4 />
      </StyledTermsPage>
    );
  }
  return (
    <StyledTermsPage>
      <BasicHeaderSection
        title="Terms of Use"
      />
      <TermsSection />
    </StyledTermsPage>
  );
}

export default TermsPage;
